// @ts-ignore
import React from "react";
import { NewModal } from '../uiMerge/newModal';
import Button from "../uiMerge/newButton";
import { Link } from "react-router-dom";

type campaignAdModalProps = {
  visible: boolean;
  onCancel: () => void | Promise<void>;
  adImage: string;
  adTitle: string;
  adLink: string;
  adCaption: string;
  onClick: () => void | Promise<void>;
};

const CampaignAdModal = ({
  visible,
  onCancel,
  adImage,
  adTitle,
  adLink,
  adCaption,
  onClick
}: campaignAdModalProps) => {

  const handleClick = () => {
    // onClick owns click-through side effects; avoid triggering close flow here.
    void onClick();
  };

  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-t-[25px]"
      colorClass="bg-black"
      position="end"
      heightClass="max-[355px]:h-full"
      showCloseButton
      className="mt-10"
      closeButtonClassName="!pt-3 !pr-2"
      onClose={onCancel}
    >
      <div className="flex bg-black rounded-t-[25px] h-full  pb-7 moverflow-y-auto flex-col items-center gap-3">
        <div className=" w-full">
          <img
            className=" rounded-t-[25px] aspect-[397/467] w-full object-cover "
            src={adImage}
            alt="Ad"
            loading="eager"
            fetchPriority="high"
          />
        </div>
        <div className="flex flex-col px-4 mt-4 w-full items-start gap-3 max-[430px]:gap-2">
          <p className="font-extrabold text-white text-left text-[20px] max-[430px]:text-[18px]">{adTitle}</p>

            <p className="font-medium text-white text-[16px] max-[430px]:text-[14px] text-left">
              {adCaption}
            </p>
        </div>
        
       <Link className="w-full mt-2 max-[430px]:mt-1 px-4" to={adLink} target="_blank">
       <Button className="w-full !rounded-[10px] max-[430px]:h-10" variant="primary" onClick={handleClick}>Click here</Button>
       </Link>
      </div>
    </NewModal>
  );
};

export default CampaignAdModal;
